import moment from "moment";
import { MonitoringErrorDetails } from "./monitoringErrorDetails";

export abstract class IMonitoringErrorsRepository {
  get: (
    availabilityZoneIds: number[],
    errorIds: number[],
    channelIds: number[],
    fromDate: moment.Moment,
    toDate: moment.Moment,
    isActive?: boolean,
  ) => Promise<MonitoringErrorDetails[]>;
}
